import { render, staticRenderFns } from "./InfoBox.vue?vue&type=template&id=2e9d3b14&scoped=true&"
var script = {}
import style0 from "./InfoBox.vue?vue&type=style&index=0&id=2e9d3b14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e9d3b14",
  null
  
)

export default component.exports